import { atom } from 'recoil';

const ShiftReloadState = atom({
    key: 'shiftReloadState',
    default: null
});

export default ShiftReloadState;